import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';

const API = '/api';

export function useSavedProperties() {
  const { user } = useAuth();
  const [savedIds, setSavedIds] = useState(new Set());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user) { setSavedIds(new Set()); return; }
    setLoading(true);
    fetch(`${API}/properties/saved/ids`, { credentials: 'same-origin' })
      .then(r => r.ok ? r.json() : [])
      .then(ids => setSavedIds(new Set(Array.isArray(ids) ? ids : [])))
      .catch(() => { /* saved-ids fetch failed silently */ })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const toggleSave = useCallback(async (propertyId) => {
    const res = await fetch(`${API}/properties/${propertyId}/save`, {
      method: 'POST',
      credentials: 'same-origin'
    });
    if (!res.ok) throw new Error('Failed');
    const data = await res.json();
    setSavedIds(prev => {
      const next = new Set(prev);
      if (data.saved) next.add(propertyId);
      else next.delete(propertyId);
      return next;
    });
    return data.saved;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isSaved = useCallback((id) => savedIds.has(id), [savedIds]);

  return { savedIds, toggleSave, isSaved, loading };
}
